<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/company/getCompanyLists"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="company_name">
          <Input type="text" v-model="searchData.company_name" placeholder="名称" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="manager_name">
          <Input type="text" v-model="searchData.manager_name" placeholder="联系人姓名或手机" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="is_del">
          <Select v-model="searchData.is_del" placeholder="状态" clearable>
            <Option value="0">正常</Option>
            <Option value="1">禁用</Option>
            <Option value="">全部</Option>
          </Select>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <!-- <FormItem>
          <Button type="primary" @click="edit(0)">添加</Button>
        </FormItem> -->
<!-- 
        <FormItem>
          <Button type="warning" @click="exportData">导出</Button>
        </FormItem> -->
      </template>
    </pageTable>

    <editForm v-if="showEditForm"
               :show-edit="showEditForm"
               :company-id="editCompanyId"
               ref="Edit"
               @cancel-edit="cancelEdit"
               @edit-success="editSuccess"
    >
    </editForm>

    <Modal
            v-model="rechargeModal"
            :title="rechargeModalTitle"
            :loading="loadingRechargeModal"
            @on-ok="doRecharge"
            @on-cancel="cancelRechargeModal">
        <Row style="justify-content: center;">
          支付方式:{{rechargeInfo.pay_type_name}}
          <Select v-model="rechargeInfo.pay_type" style="width: 120px;margin-left:10px">
            <Option value="litre">升数支付</Option>
            <Option value="amount">金额支付</Option>
          </Select>
          <Button type="primary" @click="changePayType">修改</Button>
        </Row>
        <Row style="justify-content: center;">
          单价：{{rechargeInfo.unit_price}}
          车队卡余额：{{rechargeInfo.company_balance}}
          车队余额：{{rechargeInfo.card_balance}}
          <span v-if="editAfterCompanyBalance !==''"> -> {{editAfterCompanyBalance}}</span>
        </Row>

      <Form ref="rechargeForm" :label-width="100" :model="rechargeForm">
        <FormItem label="充值金额" prop="amount">
          <Input @on-change="countCompanyBalance" v-model="rechargeForm.amount" placeholder="请输入整数,正数添加余额，负数扣除余额" maxlength="100"></Input>
        </FormItem>
        <FormItem label="充值密码" prop="password">
          <Input  v-model="rechargeForm.password" placeholder="" maxlength="100"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="rechargeForm.remark" placeholder="" maxlength="50"></Input>
        </FormItem>
      </Form>
    </Modal>

    <Drawer :title="snDrawerTitle" width="900"
            :value="isShowSnDrawer"
            :mask-closable="true"
            @on-close="closeSnDrawer">
      <CompanySn :company-id="snCompanyId" v-if="isShowSnDrawer"></CompanySn>
    </Drawer>

    <Modal
            v-model="unitPriceModal.isShow"
            :title="unitPriceModal.title"
            :loading="unitPriceModal.isLoading"
            @on-ok="changeUnitPriceFixTime"
            @on-cancel="cancelUnitPriceModal">
      <Form ref="unitPriceForm" :label-width="100" :model="unitPriceForm">
        <FormItem label="单价" prop="unitPrice">
          <Input v-model="unitPriceForm.unitPrice" placeholder="" maxlength="100"></Input>
        </FormItem>
        <FormItem label="执行时间" prop="doTime">
          <DatePicker v-model="unitPriceForm.doTime" type="datetime" placeholder="不填写则表示立即修改" style="width: 200px" />
        </FormItem>
      </Form>
    </Modal>

    <Modal
            v-model="daohangModal.isShow"
            :title="daohangModal.title"
            :loading="daohangModal.isLoading"
            @on-ok="editDaohangNum"
            @on-cancel="cancelDaohangModal">
      <Form ref="unitPriceForm" :label-width="100" :model="daohangModal">
        <FormItem label="次数" prop="num">
          <Input v-model="daohangModal.num" placeholder="负数则减去次数" maxlength="100"></Input>
        </FormItem>
      </Form>
    </Modal>

<!--    显示可加油站点列表-->
    <Drawer :title="companyStationModal.company_name" width="1600"
            :value="companyStationModal.isShow"
            :mask-closable="true"
            @on-close="companyStationModal.isShow=false">
      <CompanyStation :company-id="companyStationModal.company_id" v-if="companyStationModal.isShow"></CompanyStation>
    </Drawer>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import editForm from "./edit";
  import CompanySn from './companySn'
  import CompanyStation from "./indexStation";
  import XLSX from 'xlsx';
  export default {
    name: "fleet",
    components:{CompanyStation, pageTable,editForm,CompanySn},
    data() {
      return {
        showEditForm:false,
        editCompanyId:0,
        editAfterCompanyBalance:'',
        searchData: {
          is_del:'0',
          company_name: '',
          manager_name:'',
        },
        tableColumn: [
          {title: 'ID',key: 'company_id',align: "center"},
          {title: '公司名称',key: 'company_name',align: "center"},
          {title: '类型',key: 'type',align: "center"},
          {title: '站点类型',key: 'show_station_type',align: "center"},
          {
            title: '待处理调价',
            key: 'pending_apply_count',
            align: 'center',
            render:(h,params)=>{
              const num = Number(params.row.pending_apply_count || 0)
              if (num > 0) {
                return h('Tag',{props:{color:'warning'}},String(num))
              }
              return h('span','0')
            }
          },
          {title: '站点',key: 'station_type_name',width:120,align: "center",render:(h,params)=>{
            let content = [];
            content.push(h('Button',{
              props: {type: 'primary', size: 'small'},
              on: {click: () => {this.showStation(params.row)}}
            }, '查看'))
              if (params.row.fixed_price_time){
                content.push(
                  h('p',params.row.fixed_price_time)
                )
              }
              return h('div',content)
            }},
          {title: '业务类型',key: 'is_bill',align: "center",render:(h,params)=>{
              return h('div',[
                h('p',params.row.is_bill),
              ])
            }},
          {title: '联系方式',key: 'manager_name',align: "center",width:130,render:(h,params)=>{
              return h('div',[
                h('p',params.row.manager_name),
                h('p',params.row.manager_mobile),
              ])
            }},
          {title: '单价',key: 'unit_price',align: "center",render:(h,params)=>{
              return h('a',{
                on:{click:()=> {this.showUnitPriceModal(params.row)}}
              },params.row.unit_price)
            }},
          {title: '剩余数量',key: 'balance',align: "center",render:(h,params)=>{
              return h('div',[
                h('p',[
                  h('span',params.row.pay_type_name + ' '),
                  h('a',{
                    on:{click:()=> {this.showSnDrawer(params.row)}}
                  },params.row.balance+(params.row.pay_type==='litre' ? ' L':' 元'))
                ]),
                      h('p',params.row.is_show_balance),

              ])
            }},
          /*{title: '导航次数',key: 'balance',align: "center",render:(h,params)=>{
              return h('a',{
                on:{click:()=> {this.showDaohangModal(params.row)}}
              },params.row.daohang_num)
            }},*/
        //   {title: '是否联动',align: "center",width:120,render:(h,params)=>{
        //       let status = parseInt(params.row.is_linkage)
        //       let content  =[];
        //       content.push(h('span',status===1 ? '联动' : '不联动'))

        //       content.push(h('Icon',
        //               {
        //                 props:{type:'ios-repeat',size:'24',color:'red'},
        //                 style:{marginLeft: '5px'},
        //                 on:{
        //                   click:()=>{this.changeLinkage(params.row.company_id)}
        //                 }
        //               }
        //       ))
        //       return h('div',content)
        //     }},
          {title: '加油总量',key: 'total_litre_num',align: "center"},
          {title: '注册时间',key: 'ctime',align: "center"},
        //   {title: '操作',align: "center",width:220,render:(h,params)=>{
        //     return h('div',[
        //       h('Button',{
        //         props: {type: 'primary', size: 'small'},
        //         on: {click: () => {this.edit(params.row.company_id)}}
        //       }, '编辑'),
        //       h('Button',{
        //         props: {type: 'primary', size: 'small'},
        //         style:{marginLeft:'5px'},
        //         on: {click: () => {this.showRecharge(params.row)}}
        //       }, '充值'),
        //       h('Button',{
        //         props: {type: params.row.is_del === 0 ? 'error' : 'success', size: 'small'},
        //         style:{marginLeft:'5px'},
        //         on: {click: () => {
        //             if(params.row.is_del === 0){
        //               this.del(params.row)
        //             }else{
        //               this.regain(params.row)
        //             }
        //         }}
        //       }, params.row.is_del === 0 ? '禁用' : '恢复'),
        //     ])
        //     }},
        ],
        tableData: [],
        rechargeModal:false,
        rechargeModalTitle:'',
        loadingRechargeModal:true,
        rechargeInfo:{},
        rechargeForm:{
          company_id:0,
          amount:'',
          password:'',
          remark:'',
        },

        isShowSnDrawer:false,
        snCompanyId:0,
        snDrawerTitle:'车队流水记录',
        unitPriceModal:{
          isShow:false,
          title:'',
          isLoading:false,
        },
        unitPriceForm:{
          company_id:0,
          doTime:'',
          unitPrice:'',
        },
        companyStationModal:{
          isShow:false,
          company_id:0,
          company_name: '',
        },
        daohangModal:{
          isShow:false,
          isLoading:false,
          company_id:0,
          title:'',
          num:'',
        }
      }
    },
    methods: {
      cancelEdit(){
        this.showEditForm = false
        this.editCompanyId = 0
      },
      editSuccess(){
        this.$refs.table.getLists();
        this.showEditForm = false
        this.editCompanyId = 0
      },
      edit(company_id){
        this.showEditForm = true
        this.editCompanyId = company_id
      },
      showRecharge(company_info){
        this.rechargeModal = true
        this.rechargeModalTitle = company_info.company_name + ' 充值'
        this.rechargeForm.company_id = company_info.company_id
        this.rechargeInfo = company_info
      },
      cancelRechargeModal(){
        this.rechargeModal = false
        this.rechargeForm.company_id = 0
        this.rechargeInfo = {}
      },
      async doRecharge(){
        if (this.rechargeForm.company_id<=0 || this.rechargeForm.amount==0){
          return this.$commonFun.errorTip('请输入正确的金额')
        }
        let res = await this.$commonFun.postProxy('admin/company/rechargeCompany',this.rechargeForm);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.rechargeModal = false
            this.rechargeForm.company_id = 0
            this.$refs.table.getLists();
          })
        })
      },

      showSnDrawer(info){
        this.isShowSnDrawer = true
        this.snCompanyId = info.company_id
        this.snDrawerTitle = info.company_name
      },
      showDaohangModal(info){
        this.daohangModal.isShow = true
        this.daohangModal.company_id = info.company_id
        this.daohangModal.title = info.company_name
      },
      cancelDaohangModal(){
        this.daohangModal.isShow = false
        this.daohangModal.company_id = 0
      },
      closeSnDrawer(){
        this.isShowSnDrawer = false
        this.snCompanyId = 0
      },
      async del(info){
        this.$Modal.confirm({
          title:'禁用',
          content:`确定要禁用车队:${info.company_name} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/company/delCompany',{id:info.company_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })

      },
      async changePayType(){
        let params = {
          company_id:this.rechargeForm.company_id,
          pay_type:this.rechargeInfo.pay_type
        }
        this.$Modal.confirm({
          title:'修改支付方式',
          content:`修改后原有余额将清 0，确定要修改吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/company/changePayType',params);
            this.$Modal.remove()
            this.cancelRechargeModal()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })
      },
      async regain(info){
        this.$Modal.confirm({
          title:'恢复',
          content:`确定要恢复车队:${info.company_name} 吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/company/regainCompany',{id:info.company_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg,()=>{
                this.$refs.table.getLists();
              })
            })
          }
        })

      },
      //根据填写的金额计算剩余数量
      countCompanyBalance(e){
        let amount = this.rechargeForm.amount,pay_type = this.rechargeInfo.pay_type;
        let num = parseFloat(amount/this.rechargeInfo.unit_price).toFixed(2)
        let after_amount = (parseFloat(this.rechargeInfo.company_balance) + parseFloat(num)).toFixed(2)
        this.editAfterCompanyBalance = after_amount
      },
      showUnitPriceModal(company_info){
        this.unitPriceModal.isShow = true
        this.unitPriceModal.title = company_info.company_name + ' 单价修改'
        this.unitPriceForm.company_id=company_info.company_id
        this.unitPriceForm.unitPrice = company_info.unit_price
      },
      cancelUnitPriceModal(){
        this.unitPriceModal.isShow = false
        this.unitPriceForm.company_id=0
        this.unitPriceForm.unitPrice = ''
      },
      async changeUnitPriceFixTime(){
        if (this.unitPriceForm.company_id<=0 || this.unitPriceForm.unitPrice<=0){
          return this.$commonFun.errorTip('请输入正确的金额')
        }
        let res = await this.$commonFun.postProxy('admin/company/changeUnitPriceFixTime',this.unitPriceForm);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.unitPriceModal.isShow = false
            this.unitPriceForm.company_id=0
            this.unitPriceForm.unitPrice = ''
            this.$refs.table.getLists();
          })
        })
      },
      async editDaohangNum(){
        this.daohangModal.isLoading = true
        let res = await this.$commonFun.postProxy('admin/company/editDaohangNum',{company_id:this.daohangModal.company_id,num:this.daohangModal.num});
        this.daohangModal.isLoading = false
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.$refs.table.getLists();
          })
        })
      },
      showStation(info){
        this.companyStationModal.isShow = true
        this.companyStationModal.company_id = info.company_id
        this.companyStationModal.company_name = info.company_name
      },

      async exportData(){
        let res = await this.$commonFun.postProxy('admin/company/exportCompany',this.searchData)
        this.$commonFun.dealApiResult(res,()=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`车队信息.xlsx`)
        })
      },

      async changeLinkage(company_id){
        this.$Modal.confirm({
          content:`确定要修改吗？`,
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/company/changeLinkage',{company_id});
            this.$Modal.remove()
            this.$refs.table.getLists();
            this.$commonFun.dealApiResult(res)
          },
        })
      },
    },
    mounted() {

    },
  }
</script>

<style scoped>

</style>
